const DOCUMENT = 'ORGANIZATIONS_';

const actions = {
  LOAD_REQUEST: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_ERROR: DOCUMENT + 'LOAD_ERROR',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

  loadDataRequest: data => ({
    type: actions.LOAD_REQUEST,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadDataError: data => ({
    type: actions.LOAD_ERROR,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),
};

export default actions;
